var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.VOPlayer = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.currentTime
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return this.tag.playbackRate || 1
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.tag.webkitDroppedFrameCount
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return this._getQuality().bandwidth
  },

  /** Override to return user bandwidth throughput */
  /* getThroughput: function () {
    return this.player.estimatedBandwidth // this is not the total bandwidth, is just the video download speed
  }, */

  /** Override to return rendition */
  getRendition: function () {
    var quality = this._getQuality()
    return youbora.Util.buildRenditionString(quality.width, quality.height, quality.bandwidth)
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive()
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.src
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'VOPlayer'
  },

  _getQuality: function () {
    var ret = {
      bandwidth: null,
      width: null,
      height: null
    }
    try {
      var quality = this.player.quality
      if (this.player.qualities.length === 1) {
        quality = 0
      }
      if (quality >= 0) {
        ret = this.player.qualities[quality]
      }
    } catch (err) {
      // nothing
    }
    return ret
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    // youbora.Util.logAllEvents(this.player)
    this.tag = this.player.videoElement

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)

    // References
    this.references = {
      play: this.playListener.bind(this),
      playing: this.playingListener.bind(this),
      pause: this.pauseListener.bind(this),
      error: this.errorListener.bind(this),
      ended: this.endedListener.bind(this),
      timeupdate: this.timeupdateListener.bind(this),
      reset: this.endedListener.bind(this)
    }

    // Register listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.on(key, this.references[key])
      }.bind(this))
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.off(key, this.references[key])
      }.bind(this))
      this.references = {}
    }
  },

  /** Listener for 'play' event. */
  playListener: function () {
    this.fireStart()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function () {
    if (this.getPlayhead() > 0.1) {
      this.fireJoin()
    }
  },

  // adsLoadListener: function () {
  //  this.plugin.setAdsAdapter(new youbora.adapters.VOPlayer.NativeAdsAdapter(this.player))
  // },

  /** Listener for 'pause' event. */
  pauseListener: function () {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function () {
    this.fireResume()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    if (e.code === 0) {
      this.fireFatalError(e.code.toString(), e.message)
    } else {
      this.fireError(e.code.toString(), e.message)
    }
  },

  /** Listener for 'ended' event. */
  endedListener: function () {
    this.fireStop()
  }
}
// Static members
// {
//  NativeAdsAdapter: require('./ads/generic')
// }
)

module.exports = youbora.adapters.VOPlayer
